// removed by extract-text-webpack-plugin
module.exports = {"background":"HMBfBwTt","scroll":"_2uj_sjuM","close":"HC7AdRlb","popImg":"_23gl-Qkw","popText":"PQ-2wU8p","split-container":"_2K-btjY_"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/pages/HomePage/components/Speak/Popup.styl
// module id = 255
// module chunks = 0